import { Grid, Paper } from "@material-ui/core";
import NotificationProvider from "components/NotificationProvider";
import { selectRole } from "features/user/userSlice";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Authorize from "../../../components/Authorize";
import { hasPermission } from "../../../components/Authorize/authorizeUtil";
import { permissionProfiles } from "../../../components/Authorize/permissionProfiles";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { IconProfile } from "../../../icons";
import RoleManagement from "../components/RoleManagement";
import ActiveUsersGraphic from "./ActiveUsersGraphic";
import UsersPerClient from "./UsersPerClient";
import HeaderUserManagement from "./Header";
import InactiveUsers from "./InactiveUsers";
import TotalActiveUsers from "./TotalActiveUsers";
import UsersTable from "./UsersTable";
import { useGetAllPermissionQuery } from "./permissionSlice";
import { useDeleteRoleMutation, useGetAllRolesWithDataQuery } from "./roleSlice";
import usersPageStyle from './styles';
import { useGetAllClientsManagerQuery, useGetAllLotsManagerQuery, useGetUserManagerQuery } from "./userManagementSlice";

const UserManagementPage = () => {
    const classes = usersPageStyle();

    const [inactiveValue, setInactiveValue] = useState(3);

    let { data: users, error: usersError, isLoading: isLoadingUsers, refetch: refetchUsers, isFetching: isFetchingUsers } = useGetUserManagerQuery(inactiveValue);
    let {
        data: permission,
        error: permissionError,
        isLoading: isLoadingPermission,
        refetch: refetchPermission,
        isFetching: isFetchingPermission
    } = useGetAllPermissionQuery();
    let {
        data: rolesWithAllData,
        error: rolesWithAllDataError,
        isLoading: isLoadingRolesData,
        refetch: refetchRolesWithData,
        isFetching: isFetchingRolesData
    } = useGetAllRolesWithDataQuery();
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetAllClientsManagerQuery();
    let { data: lots, error: lotError, isLoading: isLoadingLots, isSuccess: isLotsSuccess } = useGetAllLotsManagerQuery();

    const [deleteRole, { isLoading: isLoadingDeleteRole }] = useDeleteRoleMutation();

    const userLoggedProfileRoleName = useSelector(selectRole);

    const [activeUsers, setActiveUsers] = useState([]);
    const [inactiveUsers, setInactiveUsers] = useState([]);
    const [localClients, setLocalClients] = useState([]);
    const [localClientAccounts, setLocalClientAccounts] = useState([]);
    const [localLots, setLocalLots] = useState([]);

    const roles = rolesWithAllData?.data ?? [];

    useEffect(() => {
        refetchUsers();
    }, [inactiveValue]);

    useEffect(() => {
        if (users) {
            setActiveUsers(users?.filter(user => !user.isInactiveUser && !user.isPurged && !user.isBlackList));
            setInactiveUsers(users?.filter(user => user.isInactiveUser && !user.isPurged && !user.isBlackList));
        }
        if (clients) {
            setLocalClients(clients.data);
            var accounts = clients.data?.flatMap(c => c.clientAccounts) ?? [];	
            setLocalClientAccounts(accounts);
        }
        if (lots) {
            setLocalLots(lots.data);
        }
    }, [users, permission, clients, lots, inactiveValue]);


    // useEffect(() => {
    //     if (roles && roles?.length > 0) {
    //         let myRole = roles?.find(x => x.name === userLoggedProfileRoleName);
    //         let usersFiltered = [];
    //         let allUsersList = users ?? [];

    //         allUsersList = allUsersList?.filter((user) => user?.assignedRole && user?.assignedRole?.length > 0);
    //         allUsersList?.map((user) => {
    //             const assigmentRoles = [...user?.assignedRole];
    //             let canISeeRole = myRole?.rolesKeysVisibles.some(y => y == assigmentRoles[0]?.roleId);
    //             if (canISeeRole) {
    //                 usersFiltered.push(user);
    //             }
    //         });
    //         setLocalUsersFiltered(allUsersList);
    //     }
    // }, [roles, users]);

    const mapExportData = (v) => ({
        Email: v.email,
        "User Name": v.userName,
        "Last Login Date": v.lastLoginDateFormat,
        "Last Seen Date": v.lastSeenDateFormat,
    });

    const isLoadingDashboardData = isLoadingUsers || isFetchingUsers || isLoadingPermission || isFetchingPermission || isLoadingRolesData || isFetchingRolesData || isLoadingClients || isLoadingLots;

    const onDeleteRole = async (role) => {
        if (!role) return;

        let body = {
            RoleKey: role.key,
            RoleId: role.id
        };
        let res = await deleteRole(body);

        if (res && !res.error) {
            refetchRolesWithData();
            NotificationProvider.success("Role deleted successfully");
            return true;
        } else {
            NotificationProvider.error(`Failed to delete the role ${role.Name}`);
            return false;
        }
    }

    return (<>
        <Paper className={`${classes.card} ${classes.dashboard}`} elevation={1}>
            {isLoadingDashboardData && <LoadingSpinner loading={isLoadingDashboardData} />}
            <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                    <HeaderUserManagement
                        roles={roles}
                        users={users}
                        clients={localClients}
                        lots={localLots}
                        refetchUsers={refetchUsers}
                        mapExportData={mapExportData}
                        inactiveValue={inactiveValue}
                        setInactiveValue={setInactiveValue}
                    />
                </Grid>

                <Authorize profile={permissionProfiles.USER_MANAGEMENT.TOTAL_ACTIVE_USER_SEE}>
                    <Grid item xs={6}>
                        <Paper elevation={1} className={classes.card}
                            style={{ borderTop: `7px solid #d0e1fd` }}>
                            <Grid className={classes.wrapper} container direction="column">
                                <TotalActiveUsers
                                    users={activeUsers}
                                    clients={localClients}
                                    lots={localLots}
                                    mapExportData={mapExportData}
                                    permission={permission}
                                    refetchUsers={refetchUsers}
                                    roles={roles} />
                            </Grid>
                        </Paper>
                    </Grid>
                </Authorize>

                <Authorize profile={permissionProfiles.USER_MANAGEMENT.TOTAL_INACTIVE_USER_SEE}>
                    <Grid item xs={6}>
                        <Paper elevation={1} className={classes.card}
                            style={{ borderTop: `7px solid #d0e1fd` }}>
                            <Grid className={classes.wrapper} container direction="column">
                                <InactiveUsers
                                    inactiveUsers={inactiveUsers}
                                    clients={localClients}
                                    lots={localLots}
                                    permission={permission}
                                    refetchUsers={refetchUsers}
                                    roles={roles}
                                    mapExportData={mapExportData} />
                            </Grid>
                        </Paper>
                    </Grid>
                </Authorize>

                {/* <Authorize profile={permissionProfiles.USER_MANAGEMENT.TOTAL_BLACK_LIST}>
                    <Grid item xs={6}>
                        <Paper elevation={1} className={classes.card}
                            style={{ borderTop: `7px solid #d0e1fd` }}>
                            <Grid className={classes.wrapper} container direction="column">
                                <BlackListUsers users={localUsersFiltered}
                                    clients={localClients}
                                    lots={localLots}
                                    mapExportData={mapExportData}
                                    permission={permission}
                                    refetchUsers={refetchUsers}
                                    roles={roles} />
                            </Grid>
                        </Paper>
                    </Grid>
                </Authorize> */}

                {/* <Authorize profile={permissionProfiles.USER_MANAGEMENT.TOTAL_PURGE}>
                    <Grid item xs={6}>
                        <Paper elevation={1} className={classes.card}
                            style={{ borderTop: `7px solid #d0e1fd` }}>
                            <Grid className={classes.wrapper} container direction="column">
                                <PurgeUsers users={localUsersFiltered}
                                    clients={localClients}
                                    lots={localLots}
                                    permission={permission}
                                    refetchUsers={refetchUsers}
                                    roles={roles}
                                    mapExportData={mapExportData} />
                            </Grid>
                        </Paper>
                    </Grid>
                </Authorize> */}

                <Authorize profile={permissionProfiles.USER_MANAGEMENT.ACTIVE_DASH_BY_ROL}>
                    <Grid item xs={6}>
                        <Paper elevation={1} className={classes.card}>
                            <Grid className={classes.wrapper} container direction="column">
                                <ActiveUsersGraphic users={activeUsers} loading={isLoadingUsers} roles={roles} />
                            </Grid>
                        </Paper>
                    </Grid>
                </Authorize>

                <Authorize profile={permissionProfiles.USER_MANAGEMENT.ACTIVE_DASH_PER_CLIENT}>
                    <Grid item xs={6}>
                        <Paper elevation={1} className={classes.card}>
                            <Grid className={classes.wrapper} container direction="column">
                                <UsersPerClient activeUsers={activeUsers} inActiveUsers={inactiveUsers} clients={localClients} />
                            </Grid>
                        </Paper>
                    </Grid>
                </Authorize>

                <Authorize profile={permissionProfiles.USER_MANAGEMENT.ROLE_MANAGEMENT_ACCESS}>
                    <Grid item xs={12}>
                        <Paper elevation={1} className={classes.card}>
                            <Grid className={classes.wrapper} container direction="column">
                                <RoleManagement
                                    allRoles={roles}
                                    refetchRolesWithData={refetchRolesWithData}
                                    users={users}
                                    title={"Role Management"}
                                    clients={localClients}
                                    lots={localLots}
                                    isLoading={isLoadingRolesData}
                                    isLoadingDeleteRole={isLoadingDeleteRole}
                                    onDeleteRoleFunc={onDeleteRole}
                                />
                            </Grid>
                        </Paper>
                    </Grid>
                </Authorize>

                <Authorize profile={permissionProfiles.USER_MANAGEMENT.TOTAL_VIEW_ACCESS_TABLE}>
                    <Grid item xs={12}>
                        <UsersTable
                            users={activeUsers}
                            searchVal={""}
                            clients={localClients}
                            lots={localLots}
                            roles={roles}
                            permission={permission}
                            refetchUsers={refetchUsers}
                            title={<><IconProfile /> Active Users </>}
                        />
                    </Grid>
                </Authorize>
            </Grid>
        </Paper>
    </>);
}
export default UserManagementPage;